module.exports = {"350583001":"溪美街道","350583002":"柳城街道","350583003":"美林街道","350583100":"省新镇","350583101":"仑苍镇","350583102":"东田镇","350583103":"英都镇","350583104":"翔云镇","350583105":"金淘镇","350583106":"诗山镇","350583107":"蓬华镇","350583108":"码头镇","350583109":"九都镇","350583110":"乐峰镇","350583111":"罗东镇","350583112":"梅山镇","350583113":"洪濑镇","350583114":"洪梅镇","350583115":"康美镇","350583116":"丰州镇","350583117":"霞美镇","350583118":"官桥镇","350583119":"水头镇","350583120":"石井镇","350583200":"眉山乡","350583201":"向阳乡","350583400":"雪峰管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350583.json
// module id = 1111
// module chunks = 0